"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var video_access_1 = require("./video-access");
var video_origin_1 = require("../../common/ui-selectors/video/video-origin");
exports.shouldFetchUrls = function (_a) {
    var videoUrls = _a.videoUrls, _b = _a.channelData, channelData = _b === void 0 ? {} : _b, _c = _a.videoItem, videoItem = _c === void 0 ? {} : _c, currentSiteUser = _a.currentSiteUser;
    return !videoUrls &&
        !video_origin_1.isExternalVideo(videoItem) &&
        video_access_1.canPlayFullOrPreview(channelData, videoItem, currentSiteUser);
};
//# sourceMappingURL=fetch-urls.js.map